import type { V10ClientTabId } from "../types.js";

export const V10_TAB_LABELS: Record<V10ClientTabId, string> = {
  intake: "Intake",
  summary: "Summary",
  preview: "Preview",
  proof: "Proof",
  record: "Record",
  changes: "Changes",
  requests: "Requests",
  handoff: "Handoff",
};

export function v10DefaultVisibleTabs(): readonly V10ClientTabId[] {
  return ["summary", "preview", "proof", "changes", "handoff"];
}
